import { Component, Input, OnInit, inject } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';

import { BetBuilderStandardOptionGroupComponent } from './bet-builder-standard-option-group.component';
import { MarketHelpComponent } from './market-help/market-help.component';

@Component({
    selector: 'ms-bet-builder-standard-group',
    templateUrl: './bet-builder-standard-group.component.html',
    imports: [MarketHelpComponent, BetBuilderStandardOptionGroupComponent],
})
export class BetBuilderStandardGroupComponent implements OnInit {
    sitecore = inject(Sitecore);

    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() showMarketHelp: boolean;
    @Input() eventHelpText?: string;
    @Input() sourceOfPick = SourceOfPick.Other;

    displayMultiSelectionText?: boolean = false;
    multiSelectionHelpText: string;

    ngOnInit(): void {
        if (this.sitecore.betBuilderEntainUI.messages) {
            this.multiSelectionHelpText = this.sitecore.betBuilderEntainUI?.messages?.MultiSelectionInfo;
        }

        this.displayMultiSelectionText = this.optionGroup.isMultipleSelection;
    }
}
